import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js'
import VueElementLoading from 'vue-element-loading'
import { BasicSelect } from 'vue-search-select'
import moment from 'moment'

const AUTH_HEADERS = { Authorization: 'authkey xB84JJ89Hd25' }

export default {
	name: 'ParentHubCWBReport',
	components: {
		BasicSelect,
		VueElementLoading
	},
	data() {
		return {
			isLoading: false,
			isExporting: false,
			useremail: '',
			userHubId: '',
			selectedFmHub: { value: null, text: '' },
			fmHubList: [],
			lmHubsList: [],
			hasSearched: false,
			currentPage: 1,
			pageSize: 10,
			totalRecords: 0,
			listFmHubObj: { value: '', text: '' }
		}
	},
	computed: {
		totalPages() {
			return Math.ceil(this.totalRecords / this.pageSize)
		},
		paginatedData() {
			const start = (this.currentPage - 1) * this.pageSize
			const end = start + this.pageSize
			return this.lmHubsList.slice(start, end)
		}
	},
	mounted() {
		try {
			const userdetailEncrypt = window.localStorage.getItem('userdetail')
			if (userdetailEncrypt) {
				const bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
				const plaintext = bytes.toString(CryptoJS.enc.Utf8)
				const userdetail = JSON.parse(plaintext)
				this.useremail = userdetail[0].email
				this.userHubId = userdetail[0].HubId[0]
			}
			this.loadFmHubs()
		} catch (err) {
			console.error('Error in mounted:', err)
		}
	},
	methods: {
		apiBase() {
			return apiUrl.api_url_hubops
		},

		async loadFmHubs() {
			this.isLoading = true
			try {
				console.log('Loading FM hubs from:', `${this.apiBase()}listFmParentHubsFromMapping`)
				const res = await axios.get(`${this.apiBase()}listFmParentHubsFromMapping`, {
					headers: AUTH_HEADERS
				})
				console.log('FM hubs response:', res.data)
				if (res.data && res.data.ResultCode === 100) {
					this.fmHubList = (res.data.ResponseData || []).map(hub => ({
						value: hub.fmParentHubId,
						text: hub.fmParentHubName
					}))
					console.log('FM hubs loaded:', this.fmHubList)
				} else {
					console.error('API error:', res.data)
					this.$alertify.error((res.data && res.data.ReturnMessage) || 'Failed to load FM parent hubs')
				}
			} catch (err) {
				console.error('Error loading FM parent hubs:', err)
				this.$alertify.error('Error loading FM parent hubs')
			} finally {
				this.isLoading = false
			}
		},

		selectedHub(hubData) {
			console.log('selectedHub called with:', hubData)
			this.listFmHubObj = hubData
			this.selectedFmHub = hubData
			console.log('selectedFmHub updated to:', this.selectedFmHub)
			this.lmHubsList = []
			this.hasSearched = false
			this.currentPage = 1
			this.totalRecords = 0
		},

		async fetchCWBDestinations() {
			if (!this.selectedFmHub.value) {
				this.$alertify.error('Please select an FM Hub')
				return
			}

			this.isLoading = true
			this.hasSearched = true

			try {
				const res = await axios.get(`${this.apiBase()}cwbholdrequest/fhub-cwb-destinations`, {
					params: { fmParentHubId: this.selectedFmHub.value },
					headers: AUTH_HEADERS
				})

				if (res.data && res.data.ResultCode == 100) {
					const responseData = res.data.ResponseData
					this.lmHubsList = Array.isArray(responseData) ? responseData : (responseData.destinations || [])
					this.totalRecords = res.data.TotalCount || this.lmHubsList.length
					this.currentPage = 1

					if (this.lmHubsList.length === 0) {
						this.$alertify.error(
							res.data.ReturnMessage ||
							'No LM hubs with CWB=1 found for this FM hub or config is inactive.'
						)
					}
				} else {
					this.lmHubsList = []
					this.totalRecords = 0
					this.$alertify.error(
						(res.data && res.data.ReturnMessage) || 'Error fetching destinations'
					)
				}
			} catch (err) {
				console.error(err)
				this.lmHubsList = []
				this.totalRecords = 0
				this.$alertify.error('Error fetching destinations')
			} finally {
				this.isLoading = false
			}
		},

		async exportToCSV() {
			if (this.lmHubsList.length === 0) {
				this.$alertify.error('No data to export')
				return
			}

			this.isExporting = true
			try {
				const headers = ['LM Hub ID', 'LM Hub Name']
				const data = this.lmHubsList.map(hub => [
					hub.lmHubId,
					hub.lmHubName
				])

				const csvLines = [
					headers.join(','),
					...data.map(row =>
						row.map(cell => `"${String(cell != null ? cell : '').replace(/"/g, '""')}"`)
							.join(',')
					)
				]
				const blob = new Blob([csvLines.join('\n')], { type: 'text/csv;charset=utf-8;' })
				const url = URL.createObjectURL(blob)
				const link = document.createElement('a')
				link.href = url
				link.setAttribute(
					'download',
					`FMHub_CWB_${this.selectedFmHub.text}_${moment().format('YYYYMMDD')}.csv`
				)
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
				URL.revokeObjectURL(url)
				this.$alertify.success(`Exported ${this.lmHubsList.length} hub(s)`)
			} catch (err) {
				console.error(err)
				this.$alertify.error('Error exporting data')
			} finally {
				this.isExporting = false
			}
		},

		resetForm() {
			this.selectedFmHub = { value: null, text: '' }
			this.listFmHubObj = { value: '', text: '' }
			this.lmHubsList = []
			this.hasSearched = false
			this.currentPage = 1
			this.totalRecords = 0
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/ParentHubCWBReport/ParentHubCWBReport.js